export const toggleShowLevel2 = ($level2, toggle = undefined) =>
    $level2
        .toggleClass('navigation-level-2--opened', toggle)
        .parent()
        .find('.navigation-level-1__link')
        .toggleClass('navigation-level-1__link--sub-opened', toggle);
